"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceFeePercentageCannotExceedNetworkMaximum = void 0;
const usStatesAndTerritories_1 = require("../../locations/usStatesAndTerritories");
const NATIONAL_MAX_NETWORK_SERVICE_FEE_PERCENT = 3; // 3%
const COLORADO_MAX_NETWORK_SERVICE_FEE_PERCENT = 2; // 2%
/**
 * There is a maximum service fee percentage that can be charged (3% nationally, 2% in Colorado)
 * @param state
 * @param clientServiceFeePercentage 1 is 1%, 2 is 2%, etc.
 * @param clientServiceFeePercentage  1 is 1%, 2 is 2%, etc.
 * @returns
 */
function ServiceFeePercentageCannotExceedNetworkMaximum(state, clinicServiceFeePercentage, clientServiceFeePercentage) {
    const highestServiceFeePercent = Math.max(clinicServiceFeePercentage, clientServiceFeePercentage);
    if (state == usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.Colorado) {
        return highestServiceFeePercent <= COLORADO_MAX_NETWORK_SERVICE_FEE_PERCENT;
    }
    return highestServiceFeePercent <= NATIONAL_MAX_NETWORK_SERVICE_FEE_PERCENT;
}
exports.ServiceFeePercentageCannotExceedNetworkMaximum = ServiceFeePercentageCannotExceedNetworkMaximum;
//# sourceMappingURL=ServiceFeePercentageCannotExceedNetworkMaximum.js.map